<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="ROLE LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:parameterType="{ tableRow }">
        <span>{{ _parameterTypeList(tableRow.row.parameterType) }}</span>
      </template>
      <template v-slot:action="{ tableRow }">
        <a
          href="javascript:void (0)"
          class="icon-pencil1"
          style="margin-right: 20px; color: #3a3f63"
          @click="handleEdit(tableRow.row)"
        />
        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemoveItem(tableRow.row.id)"
        >
          <a
            href="javascript:void(0)"
            class="icon-trash1"
            style="color: #3a3f63"
            slot="reference"
          />
        </el-popconfirm>
      </template>
    </table-view>

    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="844px"
      @close="handleClose"
      :close-on-click-modal="false"
      destroy-on-close
    >
      <el-card :bordered="false">
        <div class="content-wrapper">
          <div class="form-wrapper">
            <el-form
              :model="form"
              ref="form"
              label-position="top"
              :rules="rules"
            >
              <el-form-item label="Project Name" prop="name">
                <el-input style="width: 100%" v-model="form.name" />
              </el-form-item>
              <el-form-item label="Parameter Name" prop="parameterType">
                <el-select style="width: 100%" v-model="form.parameterType">
                  <el-option
                    v-for="item in parameterNameList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Value Name" prop="countryIds">
                <el-select
                  style="width: 100%"
                  v-model="form.countryIds"
                  multiple
                >
                  <el-option
                    v-for="item in valueNameList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Source" prop="source">
                <el-select style="width: 100%" v-model="form.source">
                  <el-option
                    v-for="item in sourceList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Access Role Name" prop="roleId">
                <el-select style="width: 100%" v-model="form.roleId">
                  <el-option
                    v-for="item in roleNameList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="BAU & UpliftManual Decision:"></el-form-item>
              <el-form-item
                v-for="item in form.projectManualDecisionBOS"
                :label="'GCR Rating=' + item.gcrRating"
                :key="item.gcrRating"
              >
                <el-row>
                  <el-col :span="10">
                    <el-input style="width: 100%" v-model="item.minAmount">
                      <template slot="append">Million</template>
                    </el-input>
                  </el-col>
                  <el-col :span="4">
                    <p style="text-align: center">to</p>
                  </el-col>
                  <el-col :span="10">
                    <el-input style="width: 100%" v-model="item.maxAmount">
                      <template slot="append">Million</template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item
                label="Extension Manual Decision:"
                prop="minExpiryDay"
              >
                <el-row>
                  <el-col :span="10">
                    <el-input
                      style="width: 100%"
                      v-model="form.minExpiryDay"
                      onkeyup="value=value.replace(/[^\d]/g,'')"
                    >
                      <template slot="append">days</template>
                    </el-input>
                  </el-col>
                  <el-col :span="4">
                    <p style="text-align: center">to</p>
                  </el-col>
                  <el-col :span="10">
                    <el-input
                      style="width: 100%"
                      v-model="form.maxExpiryDay"
                      onkeyup="value=value.replace(/[^\d]/g,'')"
                    >
                      <template slot="append">days</template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-card>
      <template slot="footer">
        <customize-button style="margin-right: 20px" @click="visible = false">
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleAddBtn">
          Save
        </customize-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getRoleList, getTableData, removeItem, updateOrAdd } from './api'
import { getSelectList } from '@/api'

export default {
  data() {
    const searchModel = [
      {
        label: 'Project Name',
        type: 'input',
        key: 'projectName',
      },
    ]
    const tableModel = [
      {
        label: 'Project Name',
        prop: 'name',
      },
      {
        label: 'Parameter Name',
        prop: 'parameterType',
        slotName: 'parameterType',
      },
      {
        label: 'Access Role Name',
        prop: 'roleName',
      },
      {
        label: 'Create Time',
        prop: 'createTime',
      },
      {
        label: 'Action',
        width: 120,
        slotName: 'action',
      },
    ]

    return {
      searchModel: searchModel,
      tableModel: tableModel,
      tableData: [],
      pages: {},
      visible: false,
      form: {
        name: '',
        parameterType: '',
        source: '',
        roleId: '',
        countryIds: [],
        description: '',
        minExpiryDay: '',
        maxExpiryDay: '',
        projectManualDecisionBOS: [],
      },
      rules: {
        description: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
        parameterType: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        countryIds: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        roleId: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        source: [
          { required: true, trigger: 'change', message: 'Can not be empty!' },
        ],
        name: [
          { required: true, trigger: 'blur', message: 'Can not be empty!' },
        ],
      },
      parameterNameList: [
        {
          name: 'Registration Country',
          value: 1,
        },
      ],
      sourceList: [
        {
          name: 'LENOVO',
          value: 1,
        },
        {
          name: 'CSS',
          value: 2,
        },
      ],
      valueNameList: [],
      roleNameList: [],
    }
  },
  mounted() {
    this.initTable()
  },
  created() {
    this.initFormRoleManualDecisionBOSList()
    this._getValueNameList('Country', 'valueNameList')
    this._getRoleNameList()
  },
  methods: {
    async _getValueNameList(name, list) {
      const data = await getSelectList(name)
      this[list] = data
    },
    async _getRoleNameList() {
      const data = await getRoleList()
      this.roleNameList = data
    },
    _parameterTypeList(type) {
      return this.parameterNameList.filter(item => item.value === type)[0]?.name
    },
    initFormRoleManualDecisionBOSList() {
      for (let i = 1; i <= 7; i++) {
        this.form.projectManualDecisionBOS.push({
          gcrRating: i,
          maxAmount: '',
          minAmount: '',
        })
      }
      this.form.projectManualDecisionBOS.push({
        gcrRating: 'NR',
        maxAmount: '',
        minAmount: '',
      })
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    async handleRemoveItem(id) {
      try {
        await removeItem(id)
        this.$message.success('success')
        this.initTable()
      } catch (err) {
        console.error(err)
      }
    },
    handleClose() {
      this.formId = ''
      this.$refs.form.resetFields()
      this.form.permissionIds = []
      this.form.projectManualDecisionBOS.forEach(item => {
        item.maxAmount = ''
        item.minAmount = ''
      })
      this.form.minExpiryDay = ''
      this.form.maxExpiryDay = ''
    },
    async handleAddBtn() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        const submitData = this.$cloneDeep(this.form)
        if (this.formId) submitData.id = this.formId
        await this.handleUpdateOrAdd(submitData)
      }
    },
    async handleUpdateOrAdd(params) {
      try {
        await updateOrAdd(params)
        this.$message.success('success')
        this.initTable()
        this.visible = false
      } catch (err) {
        console.error(err)
      }
    },
    handleTitleActionBtn() {
      this.visible = true
    },
    handleEdit(row) {
      this.visible = true
      this.formId = row.id

      this.$nextTick(() => {
        Object.keys(this.form).forEach(key => {
          if (key !== 'projectManualDecisionBOS') {
            this.form[key] = row[key]
          }
        })

        this.form.projectManualDecisionBOS.forEach((item, index) => {
          item.minAmount =
            row.projectManualDecisionVOS[index] &&
            row.projectManualDecisionVOS[index].minAmount
          item.maxAmount =
            row.projectManualDecisionVOS[index] &&
            row.projectManualDecisionVOS[index].maxAmount
        })
      })
    },
  },
}
</script>
